<h2 class="titulo fondo-primario color-primario-contraste">
  {{ TITULOS_PASO_ESCANER[paso()] }}
</h2>

<input type="file" class="input" #input />

<div class="escaner">
  <div
    class="canvas"
    [class.oculto]="
      paso() === PasoEscaner.FUENTE ||
      paso() === PasoEscaner.AGREGAR ||
      paso() === PasoEscaner.PDF
    "
  >
    <canvas #original id="original" class="oculto"></canvas>
    <canvas #contorno id="contorno"></canvas>
  </div>

  <div class="agregar" *ngIf="paso() === PasoEscaner.AGREGAR">
    <div *ngFor="let imagen of imagenes; let i = index" class="item">
      <div class="acciones">
        <button mat-icon-button (click)="editarImagen(i)">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button (click)="imagenes.splice(i, 1)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      <img [src]="imagen.recortada" />
    </div>
    <div class="item boton-agregar" (click)="mostrarFuenteODefault()">
      <mat-icon>add_a_photo</mat-icon>
    </div>
  </div>

  <pdf-viewer
    *ngIf="paso() === PasoEscaner.PDF"
    class="pdf"
    [src]="pdfUrl"
    [original-size]="true"
    [fit-to-page]="true"
    [show-borders]="true"
    (after-load-complete)="cargando.set(false)"
  ></pdf-viewer>

  <div class="botones">
    <button
      mat-button
      (click)="pasoAnterior()"
      color="warn boton boton-atras"
      [class.cargando]="cargando()"
      [disabled]="cargando()"
    >
      Atrás
      <mat-icon>arrow_back</mat-icon>
    </button>

    <button
      *ngIf="paso() === PasoEscaner.FUENTE && habilitarImagenes"
      mat-flat-button
      (click)="abrirSubir('imagen')"
      color="primary"
      [class.cargando]="cargando()"
      [disabled]="cargando()"
    >
      Subir Imagen
    </button>

    <button
      *ngIf="
        paso() === PasoEscaner.FUENTE && habilitarPDF && imagenes.length === 0
      "
      mat-flat-button
      (click)="abrirSubir('pdf')"
      color="primary"
      [class.cargando]="cargando()"
      [disabled]="cargando()"
    >
      Subir PDF
    </button>

    <button
      *ngIf="paso() === PasoEscaner.FUENTE && habilitarCamara"
      mat-flat-button
      (click)="abrirCamara$()"
      color="primary"
      [class.cargando]="cargando()"
      [disabled]="cargando()"
    >
      Usar Cámara
    </button>

    <button
      *ngIf="paso() !== PasoEscaner.FUENTE"
      mat-flat-button
      (click)="pasoSiguiente()"
      color="primary"
      [class.cargando]="cargando()"
      [disabled]="cargando()"
    >
      <mat-icon>check</mat-icon>
      Continuar
    </button>
  </div>
</div>
